import { render, staticRenderFns } from "./significance.vue?vue&type=template&id=eb01668c"
import script from "./significance.vue?vue&type=script&lang=js"
export * from "./significance.vue?vue&type=script&lang=js"
import style0 from "./significance.vue?vue&type=style&index=0&id=eb01668c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports